// extracted by mini-css-extract-plugin
export default {"notice":"UserInitFailedPage_notice__PPcEH","link":"UserInitFailedPage_link__f74GZ"};